import config from './defaultConfig';

export default Object.assign(config, {
    SQLiteSecret: '',
    serverKey: '',
    customUrlScheme: 'f2',
});
